$(".tab-content").hide();

$("#tabs-nav li").hover(
  function () {
    $("#tabs-nav li").removeClass("active");
    $(this).addClass("active");

    $(".tab-content").hide();
    var activeTab = $(this).find("a").attr("title");
    $(activeTab).show();
  },
  function () {}
);

$(".tabs").hover(
  function () {},
  function () {
    $(".tab-content").hide();
    $("#tabs-nav li").removeClass("active");
  }
);
